import { render, staticRenderFns } from "./home-data-ranking.vue?vue&type=template&id=654ad989&"
import script from "./home-data-ranking.vue?vue&type=script&lang=ts&"
export * from "./home-data-ranking.vue?vue&type=script&lang=ts&"
import style0 from "./home-data-ranking.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports